import {styled} from 'styled-components'

export const PreviewImage = styled.img`
  width: 100%;
  height: auto;
  vertical-align: top;
`

export const DialogInnerContainer = styled.div`
  height: 40rem;
`
